/* eslint-disable @typescript-eslint/naming-convention -- Rewrite as a react hook */
import { connect } from 'react-redux';
import { State } from 'reducers';
import { getBuildingIdByUrlSlug, HasUrlSlug } from 'selectors/buildingsSelectors';
import { getBuildingRequest } from 'actions/buildingActions';
import { Loading } from 'ui/shared/loading';
import { RouteComponentProps } from 'react-router';
import { Dispatch } from 'redux';
import { omit } from 'lodash';
import { Component } from 'react';


const mapStateToProps = (state: State, { match }: RouteComponentProps<HasUrlSlug>) => ({
    buildingId: getBuildingIdByUrlSlug(state, match.params),
});

const mapDispatchToProps = (dispatch: Dispatch, { match }: RouteComponentProps<HasUrlSlug>) => ({
    onLoadUrlSlugWrapper: (buildingId: string) => () => {
        const { urlSlug } = match.params;
        !buildingId && dispatch(getBuildingRequest(urlSlug));
    },
});

const mergeProps = (stateProps: any, { onLoadUrlSlugWrapper }: any, ownProps: any) => ({
    ...stateProps,
    ...ownProps,
    onLoadUrlSlugWrapper: onLoadUrlSlugWrapper(stateProps.buildingId),
});

const loadingStyle = {
    padding: '2em',
    fontSize: '1em',
};

export const urlSlugToBuildingId = (Target: any) => {
    class UrlSlugToBuildingIdComponent extends Component<any, any> {
        public static displayName = `UrlSlugToBuildingIdComponent(${getDisplayName(Target)})`;

        componentDidMount() {
            this.props.onLoadUrlSlugWrapper();
        }

        render() {
            const { buildingId } = this.props;
            const targetProps = omit(this.props, 'onLoadUrlSlugWrapper');
            return (
                buildingId
                    ? <Target { ...targetProps }/>
                    : <div style={ loadingStyle }>
                        <Loading/>
                    </div>
            );
        }
    }

    return connect(mapStateToProps, mapDispatchToProps, mergeProps)(UrlSlugToBuildingIdComponent);
};

function getDisplayName(WrappedComponent: any) {
    return WrappedComponent.displayName || WrappedComponent.name || 'unnamed';
}
